import React, { createContext, useContext, useState } from 'react'

// Создаем типы для контекста
type SpecsContextType = {
	isSpecsExpanded: boolean
	expandSpecs: () => void
	collapseSpecs: () => void
}

const SpecsContext = createContext<SpecsContextType | undefined>(undefined)

// Создаем провайдер контекста
export const SpecsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [isSpecsExpanded, setIsSpecsExpanded] = useState(false)

	const expandSpecs = () => setIsSpecsExpanded(true)
	const collapseSpecs = () => setIsSpecsExpanded(false)

	return (
		<SpecsContext.Provider value={{ isSpecsExpanded, expandSpecs, collapseSpecs }}>{children}</SpecsContext.Provider>
	)
}

export const useSpecsContext = (): SpecsContextType => {
	const context = useContext(SpecsContext)
	if (!context) {
		throw new Error('useSpecsContext must be used within a SpecsProvider')
	}
	return context
}
